import { Component, Input, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { MatDialog } from "@angular/material";
import { Subscription } from "rxjs";
import { Service } from "../../../services";
import { GlobalService } from "../../../global.service";
import { LoadingScreenService } from "src/app/services/loading-screen/loading-screen.service";
import { PaymentSupportService } from "src/app/flash-payment/flash-payment-core/services/payment-support.service";

@Component({
  selector: "app-mobileinfo",
  templateUrl: "./mobileinfo.component.html",
  styleUrls: ["./mobileinfo.component.sass"],
})
export class MobileinfoComponent implements OnInit {
  public tabActive = "Mis Equipos y Servicios";
  public selectBan;
  public currentList;

  @Input() index;
  @Input() ph_img;
  @Input() desc_equ;
  @Input() mark;
  @Input() instal_equ;
  @Input() val_ins_equ;

  public SubscriberInfo = [];
  public token: string = sessionStorage.getItem("token");
  loadObserver: Subscription;

  public info = [];
  public warrantyStatusinfo = [];
  public equipmentSubLenght;
  public eSNField = [];
  public totalDebt = [];
  public date_report = [];
  public payTotalDebt = [];
  public amountOfFees = [];
  public showFess = [];
  public payalert;
  public showLine: boolean;
  public valueRequested;
  public queryType;
  public AmountToAccelerate;
  public subscribernumber;
  public accountNumber;
  initialize: Subscription;
  quantityToAccelerate = 0;
  constructor(
    private loadingScreenService: LoadingScreenService,
    private global: GlobalService,
    private services: Service,
    private router: Router,
    public dialog: MatDialog,
    private route: ActivatedRoute,
    private paymentSupportService: PaymentSupportService
  ) {}

  ngOnInit() {
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.info = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo;
    this.selectBan = atob(sessionStorage.getItem("selectBan"));
    this.equipmentSubLenght;
    this.imei();
    if (this.info[this.index].equipmentInfoField.installmentsField > 0) {
      this.showFess[this.index] = false;
      this.amountOfFees[this.index] = 0;
      this.totalDebt[this.index] = parseFloat(
        this.info[this.index].equipmentInfoField.installmentRemainderField
      );
    } else {
      this.totalDebt[0] = 0;
      this.showFess[0] = false;
      this.amountOfFees[0] = 0;
    }
    this.warrantyStatusinfo = [];
    this.date_report = [];

    this.services
      .warrantyStatus(this.info[this.index].subscriberNumberField)
      .subscribe((data) => {
        //this.services.warrantyStatus("7875171050").subscribe(data => {
        if (data != null) {
          this.warrantyStatusinfo[this.index] = data.statusDescription;
          this.date_report[this.index] = data.warrantyReclamationDate;
        }
      });
  }

  imei() {
    this.eSNField = [];
    if (this.info.length != 0) {
      let contadorIMEI = 0;
      for (let i = 0; i < this.info.length; i++) {
        contadorIMEI = 0;
        for (
          let j = 0;
          j <
          this.info[i].servEquipmentSerialsField.servEquipmentSerialField
            .length;
          j++
        ) {
          if (
            this.info[i].servEquipmentSerialsField.servEquipmentSerialField[j]
              .itemIdField == this.info[i].equipmentInfoField.itemIdField
          ) {
            this.eSNField[i] =
              this.info[i].servEquipmentSerialsField.servEquipmentSerialField[
                j
              ].eSNField;
            contadorIMEI++;
          }
        }
        if (contadorIMEI == 0) {
          this.eSNField[i] = "N/A";
        }
      }
    }
  }
  changeType(sw, index) {
    if (sw == 1) {
      let subscriberNumber = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).SubscriberInfo[index].subscriberNumberField;
      let productType = JSON.parse(
        atob(sessionStorage.getItem("getAccountDetails"))
      ).SubscriberInfo[index].productTypeField;
      this.payTotalDebt[index] =
        parseFloat(this.info[index].equipmentInfoField.installmentsField) *
        parseFloat(this.info[index].equipmentInfoField.installmentValueField);
      this.showFess[index] = false;
      this.payalert = "Total a Pagar";
      this.showLine = true;
      this.valueRequested = "1";
      this.queryType = "P";
      this.loadingScreenService.startLoading();
      this.services
        .getInstallments(
          "",
          this.queryType,
          this.valueRequested,
          this.selectBan,
          subscriberNumber,
          productType,
          ""
        )
        .subscribe((data) => {
          if (data.hasError == false) {
            this.loadingScreenService.stopLoading();
            this.subscribernumber = data.subscriberNumber;
            this.accountNumber = data.accountNumber;
            this.payTotalDebt[this.index] = data.reminderInstallmentAmount;
            this.totalDebt[this.index] = data.reminderInstallmentAmount;
          } else {
            this.loadingScreenService.stopLoading();
            this.global.notif(data.errorDisplay);
          }
        });
    } else {
      this.payTotalDebt[index] =
        parseFloat(this.info[index].equipmentInfoField.installmentValueField) *
        parseFloat(this.amountOfFees[index]);
      this.showFess[index] = true;
      this.payalert = "Total a Pagar";
      this.showLine = true;
      this.queryType = "U";
    }
  }
  amountToPay(sw, index) {
    let subscriberNumber = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo[index].subscriberNumberField;
    let productType = JSON.parse(
      atob(sessionStorage.getItem("getAccountDetails"))
    ).SubscriberInfo[index].productTypeField;
    if (sw == 1) {
      if (
        this.info[index].equipmentInfoField.installmentsField >
        parseFloat(this.amountOfFees[index])
      ) {
        this.amountOfFees[index] = parseFloat(this.amountOfFees[index]) + 1;
        this.loadingScreenService.startLoading();
        this.services
          .getInstallments(
            "",
            this.queryType,
            this.amountOfFees[index],
            this.selectBan,
            subscriberNumber,
            productType,
            ""
          )
          .subscribe((data) => {
            if (data.hasError == false) {
              this.loadingScreenService.stopLoading();
              this.subscribernumber = data.subscriberNumber;
              this.accountNumber = data.accountNumber;
              this.payTotalDebt[this.index] = data.AmountToAccelerate;
              this.totalDebt[this.index] = data.reminderInstallmentAmount;
            } else {
              this.loadingScreenService.stopLoading();
              this.global.notif(data.errorDisplay);
            }
          });
      }
    } else {
      if (this.amountOfFees[index] > 0) {
        this.amountOfFees[index] = parseFloat(this.amountOfFees[index]) - 1;
        this.loadingScreenService.startLoading();
        this.services
          .getInstallments(
            "",
            this.queryType,
            this.amountOfFees[index],
            this.selectBan,
            subscriberNumber,
            productType,
            ""
          )
          .subscribe((data) => {
            if (data.hasError == false) {
              this.loadingScreenService.stopLoading();
              this.subscribernumber = data.subscriberNumber;
              this.accountNumber = data.accountNumber;
              this.payTotalDebt[this.index] = data.AmountToAccelerate;
              this.totalDebt[this.index] = data.reminderInstallmentAmount;
              this.quantityToAccelerate = data.quantityToAccelerate;
            } else {
              this.loadingScreenService.stopLoading();
              this.global.notif(data.errorDisplay);
            }
          });
      }
    }
    this.payTotalDebt[index] =
      parseFloat(this.info[index].equipmentInfoField.installmentValueField) *
      parseFloat(this.amountOfFees[index]);
    this.valueRequested = this.amountOfFees[index];
  }
  pay(index) {
    if (this.payTotalDebt[index] == 0) {
      this.global.notif(
        "Estimado cliente: Por favor seleccione un monto a pagar."
      );
    } else {
      let i = 2;
      if (i == 2) {
        let typeMessage = "payment";
        let locationId = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")))
                                    .SubscriberInfo[index].equipmentInfoField.mInvoiceStoreIdField;
        let invoiceNumber = JSON.parse(atob(sessionStorage.getItem("getAccountDetails")))
                                      .SubscriberInfo[index].equipmentInfoField.mInvoiceOIdField;
        if (sessionStorage.getItem('canUseNewMethod')) {
          this.paymentSupportService.paymentRefactorProcess('installment', this.payTotalDebt[index], this.accountNumber, this.token, locationId, invoiceNumber,  this.amountOfFees[this.index]);
        } else {
          this.oldProcess(index, typeMessage, locationId, invoiceNumber);
        }


      } else {
        this.global.notif(
          "Tu equipo no cumple con la cantidad mínima de días a partir de la activación, para permitir acelerar el pago de cuotas.  Si cree que este mensaje es error, favor de comunícate con nuestro servicio al cliente telefónico al: 787-775-0000 o vía correo electrónico: miclaro@claropr.com en caso de entender que debería permitir esta  transacción."
        );
      }
    }
  }

  oldProcess(index, typeMessage, locationId, invoiceNumber) {
    this.global.newPaymentNoLimit( 5,typeMessage, this.accountNumber,this.subscribernumber,
                                  this.payTotalDebt[index],atob(sessionStorage.getItem("email")),
                                  sessionStorage.getItem("name"),"", this.token, "", "",
                                  locationId,invoiceNumber);
  }
}
